import type { HelpFile } from '../../types/help'
import { IdentityManagerPickerTestIds } from '../../../testids/IdentityManagerPickerTestIds'

export const identityManagerPickerHelp: HelpFile = {
  docPage: '/docs/identity/onboarding',
  texts: {
    [IdentityManagerPickerTestIds.identityManagerPicker]: 'Pick the line manager identity. Search ≥ 2 characters to query active workforce identities; the result list shows the identity display name with the party display name as a secondary hint when they differ.',
    [IdentityManagerPickerTestIds.comboboxManagerIdentity]: 'Search-as-you-type for an identity by display name (matches identity OR party display name).',
    [IdentityManagerPickerTestIds.managerInactiveAdvisory]: 'The selected manager identity is not in the ACTIVE lifecycle state. The backend accepts inactive managers — this advisory is non-blocking. Confirm before saving.',
  },
}
